webpackJsonp([295],{

/***/ 1060:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX V2.4.0 released | VUX - Vue.js Mobile UI Component Framework", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1875:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1060),
  /* template */
  __webpack_require__(2092),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/v2.4.0-106.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.4.0-106.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-250ac436", Component.options)
  } else {
    hotAPI.reload("data-v-250ac436", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2092:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.4.0 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] use the same popup header style as popup-picker")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/drawer.html"
    }
  }, [_vm._v("Drawer")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] new component")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/inline-calendar.html"
    }
  }, [_vm._v("InlineCalendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] re-render when render-month is changed")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/previewer.html"
    }
  }, [_vm._v("Previewer")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Use src as msrc by default")]), _vm._v(" "), _c('li', [_vm._v("[enhance] No more force setting width and height #1426")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/radio.html"
    }
  }, [_vm._v("Radio")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add prop:selected-label-style")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/range.html"
    }
  }, [_vm._v("Range")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix the situation cannot drag to max value #1556")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-250ac436", module.exports)
  }
}

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1875);

/***/ })

});


// WEBPACK FOOTER //
// 295.7e9d861b.js